<template>
  <el-dialog title="作业任务信息" width="600px" :visible="isShow" :close-on-click-modal="false" @close="$emit('update:isShow', false)">
    <div class="message">
      <el-table
        :data="taskInfoData"
        class="global-table global-tables"
        border>
        <el-table-column label="工作日" width="80px" prop="week">
        </el-table-column>
        <el-table-column label="工作时间段">
          <template v-slot="{ row }">
            <span>{{row.time1Start}} - {{row.time1End}}</span>
            <span class="timeDis">{{row.time2Start ? row.time2Start+ ' - ' : ''}}{{row.time2End}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="list">
        <div class="item">
          <p>周期性工作：
            <el-switch
              v-model="movDetail.cuttp"
              active-value = "1"
              inactive-value = "2"
              active-color="#45db5e"
              inactive-color="var(--switch-inactive-color)"
              :disabled='true'>
            </el-switch>
          </p>
        </div>
        <div class="item">
          <p>割草间隔时间：{{movDetail.cuttpNum || '--'}}天</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Message',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    movDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      taskInfoData: []
    }
  },
  watch: {
    isShow (val) {
      if (val) {
        this.handleData()
      }
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    // 处理详情表格数据
    handleData () {
      const weekData = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      const timeList = this.movDetail.cuttimeList.map((item, index) => {
        item.week = weekData[index]
        if (item.time2Start === '00:00' && item.time2End === '00:00') {
          item.timeNumber = '1'
          item.time2Start = null
          item.time2End = null
          if (item.time1Start === '00:00' && item.time1End === '00:00') {
            item.timeNumber = '1'
            item.time1Start = null
            item.time1End = null
          }
        } else {
          item.timeNumber = '2'
        }
        return item
      })
      this.taskInfoData = timeList
      console.log('handleData', this.taskInfoData)
      for (let i = this.taskInfoData.length - 1; i >= 0; i--) {
        if (this.taskInfoData[i].isWork === '2') {
          this.taskInfoData.splice(i, 1)
        }
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .message {
    font-size: 12px;
    padding: 4px;
    .title {
      margin-bottom: 10px;
    }
    .date, .intervalWork {
      margin-bottom: 10px;
    }
    .cutGrass {
      display: flex;
      line-height: 24px;
    }
    .list {
      margin: 15px 0 10px;
      display: flex;
      justify-content: space-between;
    }
  }
</style>
